/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览----地理分布情况
 */
import styles from './geography.scss';
import commonStyles from '../common/common.scss';
import React, { PureComponent } from 'react';
import { Row, Col, Spin } from 'antd';
import { paramFilter, isNotEmpty, keyToText } from '../../../../utils/util';
import {fieldAnomaly} from '../../../../utils/formatter';
import cancel from '../../../../utils/cancel';
import BBDMapChinaDataRange from '../../../common/echarts/BBDMapChinaDataRange';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import ScoresRanking from '../../../common/scoresRanking/ScoresRanking';
import BBDPie from '../../../common/echarts/BBDPie';
import NoData from '../../../common/noData/NoData';
import { formatGeoMapOption, formatGeoTrendOption, formatGeoPieData } from '../common/formatEchartOption';
import SearchForm from './common/SearchForm';
import { statisticMap, statisticTrend, statisticPie } from '../../../../services/regulatoryStatistical';

@cancel
export default class Geography extends PureComponent {
    constructor(props) {
        super(props);
        this.mapEvents = { click: this.onMapSelect };
        this.state = {
            searchParams: {},
            selectedProvince: {},
            mapLoading: true,
            trendLoading: true,
            pieLoading: true,
            statisticText: '',
            top5: [],
            mapOption: {},
            lineOption: {},
            pieOption: {}
        };
    }

    resetLoading = () => {
        this.setState({
            mapLoading: false,
            trendLoading: false,
            pieLoading: false
        });
    };

    onSearch = (searchParams) => {
        this.setState({
            selectedProvince: {},
            searchParams,
            statisticText: keyToText(searchParams.statisticType, this.props.options.riskFakeTypes)
        }, () => {
            this.getMap();
            this.getTrend();
            this.getPie();
        });
    };

    // 获取地图数据
    getMap = () => {
        let { searchParams } = this.state;

        this.doCancel('map');
        this.setState({
            mapLoading: true
        });
        statisticMap(paramFilter({ ...searchParams }), this.addCancel('map')).then(data => {
            data = data || [];
            this.setState({
                mapLoading: false,
                mapOption: formatGeoMapOption(data),
                top5: data.slice(0, 5).filter(d => d.value && d.value > 0)
            });
        }).catch(() => {
            this.setState({
                mapLoading: false,
                mapOption: {},
                top5: []
            });
        });
    };

    // 获取折线数据
    getTrend = () => {
        let { searchParams } = this.state;

        this.doCancel('trend');
        this.setState({
            trendLoading: true
        });
        statisticTrend(paramFilter({ ...searchParams, provinceCode: this.state.selectedProvince.provinceCode }), this.addCancel('trend')).then(data => {
            data = data || [];
            this.setState({
                trendLoading: false,
                lineOption: formatGeoTrendOption(data, ['reportDate', 'avgScore', 'highCompanyCount'])
            });
        }).catch(() => {
            this.setState({
                trendLoading: false,
                lineOption: {}
            });
        });
    };

    // 获取饼图
    getPie = () => {
        let { searchParams } = this.state;

        this.doCancel('pie');
        this.setState({
            pieLoading: true
        });
        statisticPie(paramFilter({ ...searchParams, provinceCode: this.state.selectedProvince.provinceCode }), this.addCancel('pie')).then(data => {
            data = data || [];
            this.setState({
                pieLoading: false,
                pieOption: formatGeoPieData(
                    data,
                    ['industryName', 'industryCompanyCount', 'avgScore'],
                    function (param) {
                        return `${param.name} <br />占比：${param.percent}% <br />评分均值：${fieldAnomaly(param.data.score)}`;
                    }
                )
            });
        }).catch(() => {
            this.setState({
                pieLoading: false,
                pieOption: {}
            });
        });
    };

    onMapSelect = (e) => {
        let { mapOption } = this.state;
        let selectedProvince = '';
        if (!e.data || !e.data.provinceName) { // 不合理的区域和没有数据的区域
            return;
        }
        selectedProvince = e.data.selected ? {} : e.data;
        mapOption.series[0].data.forEach(d => {
            d.selected = d.name === selectedProvince.name;
        });
        mapOption.notMerge = false;

        this.setState({ selectedProvince, mapOption: { ...mapOption } }, () => {
            delete mapOption.notMerge;
            this.getTrend();
            this.getPie();
        });
    };

    scoreExtra = (d) => {
        return `共${d.companyCount}家公司`;
    };

    render() {
        const { options } = this.props;
        const { mapOption, top5, lineOption, pieOption, selectedProvince, mapLoading, trendLoading, pieLoading, statisticText } = this.state;
        const selectedProvinceName = selectedProvince.name ? selectedProvince.name : '全国';

        return (
            <div>
                <Row>
                    <Col span={15}>
                        <SearchForm options={options} onSearch={this.onSearch} onFail={this.resetLoading}/>
                        <div className={styles.mapEchart}>
                            { mapLoading ?
                                <Spin /> :
                                isNotEmpty(mapOption) ?
                                    <BBDMapChinaDataRange option={mapOption} onEvents={this.mapEvents}/> :
                                    <NoData />
                            }
                        </div>
                    </Col>
                    <Col span={9}>
                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">地域{statisticText}TOP5</p>
                            <div className={styles.progressList}>
                                { mapLoading ?
                                    <Spin /> :
                                    top5.length ?
                                        <ScoresRanking data={top5} extra={this.scoreExtra}/> :
                                        <NoData />
                                }
                            </div>
                        </div>

                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">{selectedProvinceName}{statisticText}变化情况</p>
                            <div className={styles.trendEchart}>
                                { trendLoading ?
                                    <Spin /> :
                                    isNotEmpty(lineOption)  ?
                                        <BBDLineBar option={lineOption}/> :
                                        <NoData />
                                }
                            </div>
                        </div>

                        <div className={commonStyles.wrap}>
                            <p className="wrap-title">{selectedProvinceName}行业情况</p>
                            <div className={styles.pieEchart}>
                                { pieLoading ?
                                    <Spin /> :
                                    isNotEmpty(pieOption) ?
                                        <BBDPie option={pieOption}/> :
                                        <NoData />
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/financialOverview/Geography.jsx